import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SsAuthService } from 'shared/services/SS-Auth/ss-auth.service';

@Component({
  selector: 'app-reset-password-model',
  templateUrl: './reset-password-model.component.html',
  styleUrls: ['./reset-password-model.component.css']
})
export class ResetPasswordModelComponent implements OnInit {
  resetForm: FormGroup;
  loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordModelComponent>,
    private authService: SsAuthService,
    private alertService: AlertPopupService,
  ) { }

  ngOnInit() {
    this.resetForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)]),
    });
  }

  resetPassword() {
    this.loading = true;
    this.authService.sendPasswordResetLink(this.resetForm.get('email').value).subscribe(result => {
      this.loading = false;
      if (result && result.response_info) {
        this.dialogRef.close();
        this.alertService.errorAlertSuccess(result.response_info.message);
      } else {
        this.alertService.errorAlert(result.error.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/welcome/reset-password-model/reset-password-model.component.ts